import { render, staticRenderFns } from "./TreeIcon.vue?vue&type=template&id=24bef906"
import script from "./TreeIcon.vue?vue&type=script&lang=js"
export * from "./TreeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports